import React from 'react';
import { useSelector } from 'react-redux';
import getStudioSearchCategory from 'store/studioSearch/selector/getStudioSearchCategory';
import styles from './Usps.module.scss';

const Usps = () => {
  const usps = useSelector(getStudioSearchCategory)?.usps;
  if (!usps) {
    return null;
  }
  return (
    <div className={styles.usps}>
      {usps.map((usp, index) => (
        <div key={`usp${index}`} className={styles.usp}>
          <div className={styles.icon}>{(usp as any).icon && <img src={(usp as any).icon} alt="" />}</div>
          <div>{usp.text}</div>
        </div>
      ))}
    </div>
  );
};

export default Usps;
